module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"1","matomoUrl":"https://analytics.sarvasyaspirit.com","siteUrl":"https://sarvasyascents.com"},
    },{
      plugin: require('../../../packages/gatsby-theme-sarvasya/gatsby-browser.js'),
      options: {"plugins":[],"apikey":"$2b$12$xT.mhROsWygiP2H0MWktROv2cuGwP6Xwoaa6oZrqH449dUB0gAoIy","apiURL":"https://api.sarvasyaspirit.com","websiteID":"5ecbf93aefeb3a027db10e32","availableLanguages":"en,es,de","enableNewsletterSubscribe":true},
    }]
